export default {
  sm: `
  STANDARDS
  OF AN
  ECO-
  FRIENDLY 
  DATA
  CENTER,
  DATA CENTER
  GAK
  `,
  md: `
  STANDARDS OF AN
  ECO-FRIENDLY 
  DATA CENTER,
  DATA CENTER GAK
  `
};
